<h1 class="dashboard__title">CLAAS Partner Office</h1>
@if (channelId(); as id) {
  <claas-coremedia-content-renderer [contentId]="id" />
}
